// @flow
import {values, all, equals, pipe} from 'ramda';

import type {FormType, RulesType} from 'constants/flow/flowTypesValidation';

/**
 *  Class for validation form
 */
export class Validation {
    form: FormType;
    rules: RulesType;

    /**
     * Write form and rules
     * @param {FormType} form - from
     * @param {RulesType} rules - rules from fields
     */
    constructor(form: FormType, rules: RulesType) {
        this.rules = rules;
        this.form = form;
    }

    /**
     * Validation one field form form
     * @param {string} field - name field
     * @returns {string | boolean} - if there are no errors return false
     */
    one = (field: string): string | boolean =>
        this.form[field] && this.rules[field](this.form[field].value, this.form);

    /**
     * Validation all fields form form
     * @returns {*} if there are no errors return false
     */
    all = (): {[string]: string} | false => {
        const form = Object.keys(this.form);
        const result = {};

        if (
            form.every(
                field =>
                    this.form[field].disabled ||
                    (this.rules[field] &&
                        typeof this.rules[field](this.form[field].value, this.form) !== 'string'),
            )
        ) {
            return false;
        }

        form.forEach((value: string) => {
            if (!this.form[value].disabled && this.rules[value]) {
                result[value] = this.rules[value](this.form[value].value, this.form);
            } else {
                result[value] = false;
            }
        });

        return result;
    };

    /**
     * Returns the `true` if all values after validation are equal the passed value.
     * @param {any} validationResult - The value that all fields should correspond to.
     * @returns {boolean} The flag, is all fields are valid.
     */
    allPass = (validationResult: any): boolean =>
        pipe(values, all(equals(validationResult)))(this.all());
}
